import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import { TeamField } from '@modules/team/team-field';
import ImagesField from '@shared/fields/images-field';

function label(name) {
  return i18n(`entities.club.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {}),
  logo: new ImagesField('logo', label('logo'), 'club/logo',{
    "max": 1,
    "size": 3000000
  }),
  teams: TeamField.relationToMany('teams', label('teams'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),

};

export class ClubModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
